module.exports = __webpack_public_path__ + "img/alpaclass.dea48049.svg";